import { IFlightBooking } from "@/core/interfaces/IFlightBooking.interface";

const flightBookingState: IFlightBooking = {
  bookingId: null,
  isLoading: false,
  confirmBookingLoading: false,
  cancelBookingLoading: false,
  downloadTicketLoading: false,
  travelers: [],
  mobileNumber: null,
  flightDetails: null,
  additionalPassengerFields: null,
  bookingStatus: "",
  isAddonsEnabled: false,
  addonsStatus: "",
  pnrExpiryDate: null,
  email: null,
  selectedDocument: "",
  voidTicketLoading: false,
  isPassengerLoading: false,
  passengers: [],
  isEditingPassenger: false,
  editPassengerApiErrors: null,
  errors: null,
  bookingActions: {
    is_ticket_issuance_enabled: false,
    is_refund_enabled: false,
    is_ticket_void_enabled: false,
    is_ticket_cancel_enabled: false,
    is_airline_ticket_enabled: false,
    is_download_ticket: false,
  },
  bookingPromoDealDetails: {
    total_discount_amount: null,
    promo_deal_data: [],
  },
  isAddOnsLoading: false,
  isSkipAddOnsLoading: false,
  organizationUser: null,
  createdBy: null,
  availableAddOns: null,
  extraMeals: null,
  extraBaggages: null,
  extraSeats: null,
  contact_phone: null,
  AdditionalSurcharges: null,
  bookingAlerts: null,
  approvalRequest: null,
  frequentFlyersAllowed: false,
  financialProfile: null,
  platformId: null,
  organizationName: null,
  marketingAirlineCodes: [],
  organizationId: null,
};

export default flightBookingState;
